import React from 'react';
import { List } from 'semantic-ui-react'

import TitDer from '../../../components/funcionales/titder';

// import EstilosHome from '../../css/home.css';

//Usuarios
const DetalleNivel1 = ({elemento, handleClickidLista}) => {
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className=''>{elemento.email}</td>
      <td className=''>{elemento.nombreUsuario}</td>
      <td className=''>{elemento.perfil.descrPerfil}</td>
      <td className=''>{elemento.descrOficina}</td>
      <td className=''>{elemento.descrDpto}</td>
      <td className=''>{elemento.nombreCiudad}</td>      
      <td className='' style={{color: elemento.estadoUsuario?'yellow':'#93291E', fontWeight: 'bold'}}>{elemento.estadoUsuario?'ACTIVO':'INACTIVO'}</td>
    </tr>
  )
};

const Lista = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} 
    handleClickidLista={handleClickidLista} key={elemento._id}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

const UserUsu2 = ({autorizacUA, styles, handleClick, list, handleClickidLista}) => {
  const a201001 = autorizacUA.findIndex( autorizac => autorizac === "201001" );
// console.log(list)
  return (
    <div>
      <List selection>
      <TitDer list={list} textBoton1="Usuarios" btnNuevo={a201001!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} />

      <div>
          <table className='ui blue inverted celled selectable table' style={styles.styTableSup}>
            <thead className=''>
              <tr className=''>
                <th className='' style={{width: '18%'}}>Correo electrónico</th>
                <th className='' style={{width: '18%'}}>Nombre</th>
                <th className='' style={{width: '16%'}}>Perfil</th>
                <th className='' style={{width: '16%'}}>Oficina</th>
                <th className='' style={{width: '16%'}}>Departamento</th>
                <th className='' style={{width: '16%'}}>Ciudad</th>
                <th className='' style={{width: '15%'}}>Estado</th>
              </tr>
            </thead>
            <Lista list={list} handleClickidLista={handleClickidLista}/>
          </table>
          <p></p>
        </div>

      {/* <Lista list={list} styles={styles} handleClickidLista={handleClickidLista}/> */}
      </List>
    </div>
  )
};

export default UserUsu2